import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'fi';
    document.title = 'MATIKKA VALMIS™ – Valmiit matematiikan tunnit 1.–9. luokille';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mjzsz5e2v41t">
      <div lang="fi" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3rc9du70c5dx8">
        <CountdownBar data-id="element-2" data-mp="3relvej26lm9r" />
        <main data-id="element-3" data-mp="5opww5kum4f">
          <Hero data-id="element-4" data-mp="6801qozk67w" />
          <StatsBar data-id="element-5" data-mp="4n6a3ahwrb3" />
          <Difference data-id="element-6" data-mp="56qjqnmbrsa" />
          <Recognize data-id="element-7" data-mp="2zl3azit8d249" />
          <WhatsInside data-id="element-8" data-mp="2zlld2w2kqak3" />
          <InsidePages data-id="element-9" data-mp="2zmeoiach9o8k" />
          <Bonuses data-id="element-10" data-mp="2zmwl5831y4h0" />
          <HowItWorks data-id="element-11" data-mp="33mou3lwcycmw" />
          <Audience data-id="element-12" data-mp="33m5c656pjo8v" />
          <Offer data-id="element-13" data-mp="33nq921ghvj9w" />
          <Guarantee data-id="element-14" data-mp="33n6w6z5pbl2q" />
          <Testimonials data-id="element-15" data-mp="33oi2p6qj76xj" />
          <Faq data-id="element-16" data-mp="38l8hzruihyhw" />
          <FinalCta data-id="element-17" data-mp="38li6fazwrxlh" />
        </main>
        <Footer data-id="element-18" data-mp="38kgmeh0x00rm" />
      </div>
    </MotionConfig>;
}